import type { DivisionRole } from '../../../shared/api/tasks.api';

/**
 * Как роль называется для человека.
 *
 * В базе это `editor`, `content_maker` и так далее — слова для запросов, а не
 * для экрана. На встрече эти люди называют себя монтажёрами и контент-мейкерами,
 * и подпись под именем должна совпадать с тем, как человек сам себя зовёт.
 */
export const DIVISION_ROLE_LABEL: Record<DivisionRole, string> = {
  head: 'Руководитель',
  content_maker: 'Контент-мейкер',
  editor: 'Монтажёр',
  moderator: 'Модератор',
  distributor: 'Редакция',
};
